import React from "react";

export default function glassesAviator(): React.ReactElement {
  return (
    <svg
      style={{
        width: "100%",
        height: "22%",
        position: "absolute",
        top: "0%",
        left: "-3%",
      }}
      width="152"
      height="70"
      viewBox="0 0 152 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Left lens - teardrop shape */}
      <path
        d="M30 20C30 20 25 25 25 35C25 50 35 60 55 60C70 60 80 50 80 35C80 25 75 20 75 20L52 15L30 20Z"
        stroke="black"
        strokeWidth="3"
        fill="none"
      />
      {/* Right lens - teardrop shape */}
      <path
        d="M95 15C95 15 90 18 90 28C90 43 100 53 120 53C135 53 145 43 145 28C145 18 140 15 140 15L117 10L95 15Z"
        stroke="black"
        strokeWidth="3"
        fill="none"
      />
      {/* Bridge */}
      <path d="M80 25C80 22 85 20 90 20" stroke="black" strokeWidth="3" />
      {/* Left temple */}
      <path d="M30 25L5 30" stroke="black" strokeWidth="3" />
    </svg>
  );
}
